import React from "react";

function Footer() {
	return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // backgroundColor: "#2292A4",
        color: "white",
        padding: "0.5vh",
      }}
      className="bg-teal-700"
    >
      Developed By AssertAI.
    </div>
  );
}

export default Footer;
